import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { HAS_DISMISSED_SHIPPING_LIMIT_BANNER, useUserSpecificLocalStorage } from '../../../hooks/use-local-storage';
import Global from '../../../store/global-selectors';
import { hasZeroShipmentLimit } from './has-zero-shipment-limit';

export const PercentageValue = {
  EIGHTY: 80,
  NINETY_FIVE: 95,
  ONE_HUNDRED: 100,
};

export const useShippingPlanInfo = () => {
  const [hasDismissedBanner] = useUserSpecificLocalStorage(HAS_DISMISSED_SHIPPING_LIMIT_BANNER);

  const planInfo = useSelector(Global.selectSellerPlanInfo);

  const { isUnlimited = false, limit } = planInfo?.plan?.shipmentLimit || {};
  const { shipments: current } = planInfo?.usage || {};

  const percentage = useMemo(() => {
    if (isUnlimited) return 0;
    if (limit === 0) return 100;
    return Math.round(((current ?? 0) / limit) * 100);
  }, [isUnlimited, limit, current]);

  const showBanner = useMemo(() => {
    if (percentage >= PercentageValue.EIGHTY && percentage < PercentageValue.NINETY_FIVE && !hasDismissedBanner) return true;
    return percentage >= PercentageValue.NINETY_FIVE && percentage <= PercentageValue.ONE_HUNDRED;
  }, [percentage, hasDismissedBanner]);

  return {
    showBanner,
    limit,
    current,
    percentage,
    isUnlimited,
    hasZeroLimit: hasZeroShipmentLimit(planInfo?.plan?.shipmentLimit),
  };
};
